import { BaseResource } from "./BaseResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
class FlowActionResource extends BaseResource {
    pk() {
        return "_";
    }
}
FlowActionResource.urlRoot = legacyApiResourceUrl("Admin/FlowTest/Flows");
export { FlowActionResource };
//# sourceMappingURL=FlowActionResource.js.map